import { render, staticRenderFns } from "./URegisterEmailEditComp.vue?vue&type=template&id=20a4afb1&scoped=true&"
import script from "./URegisterEmailEditComp.vue?vue&type=script&lang=ts&"
export * from "./URegisterEmailEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterEmailEditComp.vue?vue&type=style&index=0&id=20a4afb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a4afb1",
  null
  
)

export default component.exports